module.exports = __webpack_public_path__ + "c_static/img/A1-1-1我的微信.34ec503.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/完善资料/A1-1-1我的微信.jpg
// module id = 2hGh
// module chunks = 33